import DOMPurify from 'isomorphic-dompurify'

export default function (source: string) {
  return DOMPurify.sanitize(source)
}
